import MapControlPopover from '../MapControlPopover';
import type { ReactNode } from 'react';

import { DRAWING_TOOL } from 'components/Map/constants';
import CircleToolIcon from 'components/icons/CircleToolIcon';
import PolygonIcon from 'components/icons/PolygonIcon';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { Props } from './types';

const DrawingToolDropdown = ({ drawingTool, onDrawingToolChange, testId = TEST_ID }: Props) => {
    const { CIRCLE, POLYGON } = useTranslation();

    const circleText = (
        <>
            <CircleToolIcon />

            {CIRCLE}
        </>
    );
    const polygonText = (
        <>
            <PolygonIcon />

            {POLYGON}
        </>
    );
    const drawingToolText: Record<DRAWING_TOOL, ReactNode> = {
        [DRAWING_TOOL.CIRCLE]: circleText,
        [DRAWING_TOOL.POLYGON]: polygonText
    };

    const drawingToolIcon: Record<DRAWING_TOOL, ReactNode> = {
        [DRAWING_TOOL.CIRCLE]: <CircleToolIcon />,
        [DRAWING_TOOL.POLYGON]: <PolygonIcon />
    };

    const options = [
        { label: CIRCLE, value: DRAWING_TOOL.CIRCLE },
        { label: POLYGON, value: DRAWING_TOOL.POLYGON }
    ];

    return (
        <MapControlPopover
            displayIcon={drawingToolIcon[drawingTool]}
            displayText={drawingToolText[drawingTool]}
            onChange={onDrawingToolChange}
            options={options}
            testId={testId}
            value={drawingTool}
        />
    );
};

export default DrawingToolDropdown;
